"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageContentMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _mediaBreakpointMixin = require("../mediaBreakpointMixin");
var _FlexMixin = require("./FlexMixin");
var PageContentMixin = function PageContentMixin(props) {
  return (0, _styledToken.default)({
    maxWidth: 'Page.maxWidth',
    horizontalPadding: 'Page.horizontalPadding',
    horizontalPaddingMobile: 'Page.horizontalPaddingMobile',
    verticalMargin: 'Page.verticalMargin'
  }, function (tokens) {
    return (0, _styledComponents.css)(["box-sizing:content-box;max-width:", ";margin:", "px auto;padding-left:", "px;padding-right:", "px;@media ", "{padding-left:", "px;padding-right:", "px;}", ""], props.fluid ? 'none' : tokens.maxWidth + "px", tokens.verticalMargin, tokens.horizontalPadding, tokens.horizontalPadding, (0, _mediaBreakpointMixin.mediaBreakpointMixin)('sm_lte')(props), tokens.horizontalPaddingMobile, tokens.horizontalPaddingMobile, (0, _FlexMixin.FlexMixin)(props));
  })(props);
};
exports.PageContentMixin = PageContentMixin;